export default __webpack_public_path__ + "static/media/Group 2142.bd86aa63.svg";